export default __webpack_public_path__ + "static/media/black-polyline-measure-icon.daae5448.svg";